import Script from 'next/script';

type GooglePlacesScriptProps = {
  libraries?: string[];
  onLoad?: () => void;
};

export function GooglePlacesScript({
  libraries = ['places'],
  onLoad,
}: GooglePlacesScriptProps) {
  const key = process.env.NEXT_PUBLIC_GOOGLE_MAPS_SEARCH_KEY;
  if (!key) return null;

  const params = new URLSearchParams({
    key,
    libraries: libraries.join(','),
    loading: 'async',
  });

  return (
    <Script
      id="google-places-script"
      src={`https://maps.googleapis.com/maps/api/js?${params.toString()}`}
      strategy="afterInteractive"
      onLoad={onLoad}
      onReady={onLoad}
    />
  );
}
